import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get an emergency passport in Nashville, TN?",
    a: "Fast Passport Center offers emergency passport processing in Nashville, Tennessee in as little as 24–48 hours. Our registered couriers have direct access to the Atlanta Passport Agency at 805 Broadway Suite 400 — the only regional passport agency in Tennessee. Nashville residents have a unique local advantage over all other Tennessee cities.",
  },
  {
    q: "Does Nashville have a passport agency?",
    a: "Yes — Nashville is the only city in Tennessee with a regional passport agency. The Atlanta Passport Agency is located at 805 Broadway Suite 400, Nashville, TN 37203. This gives Nashville residents a significant advantage over Memphis, Knoxville, and Chattanooga residents who would need to travel to another state or use a courier service.",
  },
  {
    q: "Can I get an expedited passport in Franklin, Brentwood, or Murfreesboro?",
    a: "Absolutely. Fast Passport Center serves all of Middle Tennessee including Franklin, Brentwood, Murfreesboro, Hendersonville, Smyrna, Spring Hill, Gallatin, Lebanon, Mount Juliet, Hermitage, Antioch, Goodlettsville, Dickson, and Clarksville. Our courier service works the same way everywhere — with the Atlanta Passport Agency as the processing hub.",
  },
  {
    q: "What airport do Nashville travelers use for international flights?",
    a: "Nashville International Airport (BNA) is the primary airport for Nashville and Middle Tennessee. BNA offers direct flights to London, Toronto, Cancun, and numerous European and Caribbean destinations. Always verify passport validity for at least 6 months past your return date.",
  },
  {
    q: "How much does an expedited passport cost in Nashville, TN?",
    a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline.",
  },
  {
    q: "Where can I get passport photos in Nashville?",
    a: "Walgreens, CVS, and UPS Store locations throughout Nashville, Franklin, and Murfreesboro offer passport photos. FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months.",
  },
  {
    q: "Does Fast Passport Center serve Vanderbilt University students?",
    a: "Yes. Fast Passport Center serves all of Middle Tennessee including Vanderbilt University students, faculty, and staff. We understand academic conference schedules and study abroad deadlines. Our direct Atlanta Passport Agency access is especially valuable for students with tight timelines.",
  },
  {
    q: "Is Atlanta Passport Agency faster than other agencies?",
    a: "For Nashville-area residents, absolutely. Because the Atlanta Passport Agency is local, our couriers can hand-deliver and retrieve documents same-day in many cases. Other Tennessee cities like Memphis, Knoxville, and Chattanooga require either courier service to Nashville or a long drive to Atlanta or New Orleans.",
  },
];

export default function NashvilleFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Nashville Passport Questions
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Have questions about expedited passports in Nashville, TN? Here are the most common ones we hear from Middle Tennessee travelers.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-start justify-between gap-4 p-6 text-left cursor-pointer"
              >
                <span className="font-semibold text-[#1A365D] text-base leading-snug">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i
                    className={`ri-arrow-down-s-line text-[#1A365D] text-xl transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}